function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M24.48 10h-8.96A5.526 5.526 0 0 0 10 15.52v8.96A5.525 5.525 0 0 0 15.52 30h8.96A5.526 5.526 0 0 0 30 24.48v-8.96A5.526 5.526 0 0 0 24.48 10zm3.746 14.48a3.75 3.75 0 0 1-3.745 3.746h-8.962a3.749 3.749 0 0 1-3.745-3.745v-8.962a3.749 3.749 0 0 1 3.745-3.745h8.962a3.75 3.75 0 0 1 3.745 3.745v8.962zM20 15c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm0 8.278A3.282 3.282 0 0 1 16.722 20 3.282 3.282 0 0 1 20 16.722 3.282 3.282 0 0 1 23.278 20 3.282 3.282 0 0 1 20 23.278zM25 13a1.004 1.004 0 0 0-1 1 1.006 1.006 0 0 0 1 1c.264 0 .52-.107.707-.293a1.004 1.004 0 0 0 0-1.415A1.004 1.004 0 0 0 25 13z"
});

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Instagram.c27fe0a6.svg";
export { ForwardRef as ReactComponent };